import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { FormikProvider } from 'formik'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  DialogActions,
  debounce,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import {
  useBonusDialog,
  useExcludedGamesActions,
  useExcludedGamesForm,
} from '@/views/bonus-engine/hooks'

import { DialogsEnum } from '@/enums'
import InputFormikAutocomplete from '@/views/components/input-formik-autocomplete/index.component'

export const ExcludedGamesFormComponent = () => {
  const { t } = useTranslation()

  const { dialog, toggleDialog } = useBonusDialog()

  const { getAllGames, setCurrentGame } = useExcludedGamesActions()

  const {
    formikGame,
    currentGame,
    gamesList,
    excludedGames,
    handleSaveExcludedGame,
  } = useExcludedGamesForm()

  // eslint-disable-next-line
  const filterGame = useCallback(
    debounce((value: string) => {
      getAllGames({
        game: value,
      })
    }, 500),
    [], // eslint-disable-line
  )

  const handleCloseDialog = () => {
    toggleDialog(false, DialogsEnum.DIALOG_EXCLUDED_GAMES_FORM)
    setCurrentGame()
  }

  return (
    <>
      <Dialog
        open={
          dialog.open && dialog.id === DialogsEnum.DIALOG_EXCLUDED_GAMES_FORM
        }
        aria-labelledby="dialog-games-form"
        fullWidth
        sx={{ '& .MuiPaper-root': { width: '500px' } }}
      >
        <DialogTitle id="dialog-games-form" sx={{ padding: '16px 24px 0px' }}>
          <Box display="flex" justifyContent="space-between" width="100%">
            <Box>{t('labels.excludedGames')}</Box>
            <IconButton
              aria-label="close"
              onClick={handleCloseDialog}
              size="small"
            >
              <Close fontSize="inherit" />
            </IconButton>
          </Box>
        </DialogTitle>
        <FormikProvider value={formikGame}>
          <DialogContent>
            <Box overflow="hidden">
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <InputFormikAutocomplete
                    name="game"
                    label={t('labels.game')}
                    placeholder={t('labels.searchByName')}
                    options={gamesList || []}
                    getOptionLabel={(option) =>
                      option.name ? option.name : ''
                    }
                    getOptionDisabled={(option) =>
                      excludedGames.games?.some(
                        (game) =>
                          Number(game.gameId) === Number(option.id) &&
                          Number(game.gameProviderId) ===
                            Number(option.vendorExternalID),
                      )
                    }
                    chipTags
                    freeSolo
                    inputOnChange={(search: string) => {
                      filterGame(search)
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    label={t('labels.isBlocked')}
                    control={
                      <Checkbox
                        name="isBlocked"
                        checked={formikGame.values.isBlocked}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          formikGame.setFieldValue(
                            'isBlocked',
                            !formikGame.values.isBlocked,
                          )
                        }
                      />
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
        </FormikProvider>
        <DialogActions>
          <Button onClick={handleCloseDialog} className="red">
            {t('labels.cancel')}
          </Button>
          <Button
            disabled={!(formikGame.isValid && formikGame.dirty)}
            variant="contained"
            onClick={handleSaveExcludedGame}
          >
            {currentGame?.gameId ? t('labels.update') : t('labels.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
